module.exports = __webpack_public_path__ + "static/media/skill_total.8a08a1a3.png";